import { render, staticRenderFns } from "./DragOverlay.vue?vue&type=template&id=acc157b2&"
import script from "./DragOverlay.vue?vue&type=script&lang=js&"
export * from "./DragOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports